import { Button } from '@/client/components/ui/button';
import { useRouterState } from '@tanstack/react-router';
import { Bell, Moon, Search, Sun } from 'lucide-react';
import { useCallback, useState } from 'react';

const TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/people': 'People',
  '/projects': 'Projects',
  '/timesheets': 'Timesheets',
  '/timesheets/admin': 'All Timesheets',
  '/finance': 'Finance',
  '/invoices': 'Invoices',
  '/invoices/new': 'New Invoice',
  '/analytics': 'Analytics',
  '/settings': 'Settings',
  '/timeoff': 'Time Off',
};

export function TopBar() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const title =
    TITLES[pathname] ??
    Object.entries(TITLES).find(([k]) => k !== '/' && pathname.startsWith(`${k}/`))?.[1] ??
    'Gara';
  const [isDark, setIsDark] = useState(() => document.documentElement.classList.contains('dark'));

  const toggleTheme = useCallback(() => {
    const next = !isDark;
    setIsDark(next);
    document.documentElement.classList.toggle('dark', next);
    localStorage.setItem('theme', next ? 'dark' : 'light');
  }, [isDark]);

  return (
    <header className="flex h-14 shrink-0 items-center gap-4 border-b px-6">
      <h2 className="flex-1 text-base font-semibold tracking-tight">{title}</h2>
      <div className="relative" aria-hidden="true">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <input
          type="search"
          placeholder="Search…"
          readOnly
          tabIndex={-1}
          aria-hidden="true"
          className="h-9 w-60 rounded-md border bg-background pl-8 pr-3 text-sm outline-none placeholder:text-muted-foreground"
        />
      </div>
      <Button
        variant="ghost"
        size="icon"
        type="button"
        onClick={toggleTheme}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
      </Button>
      <Button variant="ghost" size="icon" type="button" aria-label="Notifications">
        <Bell className="h-4 w-4" />
      </Button>
    </header>
  );
}
